import { useState, useEffect } from "react"
import Layout from "../Frames/Layout"
import Kpis from "./Kpis"
import { Button, Stack, Tab, Tabs } from "@mui/material"
import API from "../../services/API"
import Loader from "../Tools/Loader"
import Contacts from "./Contacts"
import { Add } from "@mui/icons-material"
import { Link } from "react-router-dom"
import { txt } from "../../services/translation"
import { TabContext, TabPanel } from "@mui/lab"
import Enrollments from "./Enrollments"

export default function Dashboard(){

    const [data, setData] = useState(null)

    const [tab, setTab] = useState('users') 

    useEffect(() => {

        API.get('/companies/me')
            .then(r => setData(r.data))

    }, [])

    return <Layout tab='company' menu='main' title={txt('companySpaceTitle')}>

        {data && 
            <Stack>

                <Kpis data={data.company} />

                <TabContext value={tab}>

                    <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>

                        <Tabs value={tab} onChange={(_,v) => setTab(v)}>
                            <Tab label={txt('users')} value='users' />
                            <Tab label={txt('enrollments')} value='enrollments' />
                        </Tabs>


                        <Button 
                            startIcon={<Add />}
                            component={Link}
                            to='/company/contacts/new/edit'
                        >
                            {txt('createUser')}
                        </Button>

                    </Stack>
                    
                    <TabPanel value='users' sx={{p: 0, m: 0}}>
                        <Contacts />
                    </TabPanel>

                    <TabPanel value='enrollments' sx={{p: 0, m: 0}}>
                        <Enrollments />
                    </TabPanel>
                    
                </TabContext>

            </Stack>
        }

        {!data && <Loader />}

    </Layout>
}